import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Box } from '@mui/material';
import Select from 'react-select';

import { getUsers } from '../../../../services/UserService';
import './AddEmployee.css';

const AddEmployee = forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [users, setUsers] = React.useState([]);
  const [name, setName] = useState();
  const [id, setId] = useState();
  const [selected, setSelected] = useState('');
  const [isLastActionFocus, setIsLastActionFocus] = useState(false);

  useImperativeHandle(ref, () => {
    return { id: id, name: name };
  });

  const { currentOfficeEmployees } = props;

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const getNames = async (name) => {
    setIsLoading(true);
    const userList = await getUsers(name);
    setUsers((prev) => []);
    if (userList.data.content) {
      userList.data.content
        .filter(
          (user) =>
            user.status === 'ACTIVE' &&
            currentOfficeEmployees
              .filter((item) => item?.id)
              .findIndex(
                (employeee) =>
                  (employeee.id ? employeee.id : employeee.id) === user.id,
              ) === -1,
        )
        .forEach((user) => {
          const usersToSet = {
            value: user.id,
            label: user.firstName + ' ' + user.lastName + ' (' + user.employeeCode + ')',
          };
          setUsers((prev) => [...prev, usersToSet]);
        });
      setIsLoading(false);
    }
  };

  const optimizedFn = React.useCallback(debounce(getNames), []);

  return (
    <Box style={{ display: 'flex' }}>
      <Box className="search-bar">
        <Select
          blurInputOnSelect={true}
          maxMenuHeight={125}
          placeholder="Please select the employee name..."
          name="empName"
          isLoading={isLoading}
          isSearchable={true}
          options={users}
          onInputChange={(e) => {
            if (e !== '') {
              setIsLastActionFocus(false);
              optimizedFn(e);
              setSelected(e);
            } else {
              setUsers(() => []);
            }
          }}
          onFocus={() => {
            setIsLastActionFocus(true);
          }}
          onBlur={() => {
            setIsLastActionFocus(false);
          }}
          value={isLastActionFocus ? '' : selected}
          onChange={(choice) => {
            setSelected(choice);
            setName(choice.label);
            setId(choice.value);
          }}
        />
      </Box>
    </Box>
  );
});

export default AddEmployee;
